import React from 'react';
import { useSelector } from "react-redux";
import PersonalDetails from '../../login/registration_form/registration_form';
import * as routes from 'constants/routes';

import arrow from 'assets/icons/arrow-black.svg';
import personal_details from 'assets/icons/personal-menu-details.svg';
import {getMediaPath} from "../../../app/functions";

const PersonalDetailsWrapper = (props) =>{

    //import redux state
    const text = useSelector(state => state.config.Translations);
    const deviceState = useSelector(state => state.state.deviceState);
    const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';

    const handleBackClick = () => {
        props.history.push(routes.personal_zone);
    }

    return(
        <div className="mobile-layout open">
            <div className='top'>
                <img src={isDesktop ? getMediaPath(personal_details) : getMediaPath(arrow)} className="icon" alt='' onClick={ handleBackClick } />
                <span className="title">{text['personal_zone_details']}</span>
            </div>
            <PersonalDetails btnText={text['update_user_btn']}/>
        </div>
    )
};

export default PersonalDetailsWrapper;